import { tricks } from "../data/tricks";

export const trickToLink = (name: string) => {
  const trick = tricks[name];

  if (!trick) {
    return { name: name, path: `/${name.replaceAll(" ", "_")}` };
  }

  return { name: name, path: `/Tricks/${trick.path}` };
};
